export default __webpack_public_path__ + "static/media/application-browser.6d893386.png";